import { render, staticRenderFns } from "./withdrawConfig.vue?vue&type=template&id=344f3182&scoped=true&"
import script from "./withdrawConfig.vue?vue&type=script&lang=js&"
export * from "./withdrawConfig.vue?vue&type=script&lang=js&"
import style0 from "./withdrawConfig.vue?vue&type=style&index=0&id=344f3182&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f3182",
  null
  
)

export default component.exports